import React from "react";
import { getSubscriptionPlanChoiceLabel } from "features/OfferingVariations/utils/OfferingVariations.utils";
import { colomnKeys } from "../../OfferingVariationsList.constants";
import { useOfferingVariationListStore } from "../../store/useOfferingVariationList.store";

export const SubscriptionPlanField = ({ record }) => {
  const offeringDetails = useOfferingVariationListStore(
    (state) => state.offeringDetails
  );
  return (
    <div>
      {record[colomnKeys.subscription_plan.magnitude]}&nbsp;
      {getSubscriptionPlanChoiceLabel({
        offeringDetails,
        selectedRecord: record,
      })}
    </div>
  );
};
